import { createSlice } from "@reduxjs/toolkit";
import axios from "axios";

const careersSlice = createSlice({
  name: "careers",
  initialState: {

    header: {
      data: [],
      loading: false,
      error: null,
    },
    flyer: {
      data: [],
      loading: false,
      error: null,
    },

    job: {
      data: [],
      loading: false,
      error: null,
    },
  },
  reducers: {

    fetchHeaderStart(state) {
        state.header.loading = true;
        state.header.error = null;
      },
      fetchHeaderSuccess(state, action) {

        state.header.loading = false;
        state.header.data = action.payload;
      },
      fetchHeaderFailure(state, action) {
        state.header.loading = false;
        state.header.error = action.payload;
      },

      fetchFlyerStart(state) {
        state.flyer.loading = true;
        state.flyer.error = null;
      },
      fetchFlyerSuccess(state, action) {

        state.flyer.loading = false;
        state.flyer.data = action.payload;
      },
      fetchFlyerFailure(state, action) {
        state.flyer.loading = false;
        state.flyer.error = action.payload;
      },

      fetchJobStart(state) {
        state.job.loading = true;
        state.job.error = null;
      },
      fetchJobSuccess(state, action) {

        state.job.loading = false;
        state.job.data = action.payload;
      },
      fetchJobFailure(state, action) {
        state.job.loading = false;
        state.job.error = action.payload;
      },

  },
});


export const {
    fetchHeaderStart,
    fetchHeaderSuccess,
    fetchHeaderFailure,
    fetchFlyerStart,
    fetchFlyerSuccess,
    fetchFlyerFailure,
    fetchJobStart,
    fetchJobSuccess,
    fetchJobFailure,
} = careersSlice.actions;

export const fetchHeaderData = () => async (dispatch) => {
    dispatch(fetchHeaderStart());
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_BACKEND_URL}/Careers/getCareerHeader`
      );
      console.log("API Response:", response.data); // Debug log
      const data = response.data.data || [];
      dispatch(fetchHeaderSuccess(data));
    } catch (error) {
      console.error("API Error:", error);
      dispatch(fetchHeaderFailure(error.message || "Something went wrong"));
    }
  };


  export const fetchFlyerData = () => async (dispatch) => {
    dispatch(fetchFlyerStart());
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_BACKEND_URL}/Careers/getCareerFlyer`
      );
      //console.log("API Response:", response.data); // Debug log
      const data = response.data.data || [];
      dispatch(fetchFlyerSuccess(data));
    } catch (error) {
      console.error("API Error:", error);
      dispatch(fetchFlyerFailure(error.message || "Something went wrong"));
    }
  };


  export const fetchJobData = () => async (dispatch) => {
    dispatch(fetchJobStart());
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_BACKEND_URL}/Careers/getJobListing`
      );
      //console.log("API Response:", response.data); // Debug log
      const data = response.data.data || [];
      dispatch(fetchJobSuccess(data));
    } catch (error) {
      console.error("API Error:", error);
      dispatch(fetchJobFailure(error.message || "Something went wrong"));
    }
  };

export default careersSlice.reducer;